"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _experimentTypeUtils = require("./experimentTypeUtils.js");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Message on top of the chart: “Showing 3 experiments:”, “Showing 12 genes of 432 found:”, “Showing 32 genes:”...
var introductoryMessage = function introductoryMessage(experiment, profiles) {
  var shownRows = profiles.rows.length;
  var totalRows = +(profiles.searchResultTotal || shownRows);
  var what = (experiment ? experiment.type.toUpperCase().includes("PROTEOMICS") ? "protein" : "gene" : "experiment") + (totalRows > 1 ? "s" : "");
  return shownRows > 0 ? "Showing ".concat((0, _utils.numberWithCommas)(shownRows), " ") + (totalRows === shownRows ? what + ":" : "of ".concat((0, _utils.numberWithCommas)(totalRows), " ").concat(what, " found:")) : "";
};

var plusDecode = function plusDecode(str) {
  return decodeURIComponent(str.replace(/\+/g, "%20"));
};

var multiExperimentQueryDescription = function multiExperimentQueryDescription(_ref) {
  var geneQuery = _ref.geneQuery,
      conditionQuery = _ref.conditionQuery,
      species = _ref.species;
  // Since Atlas uses URLEncoder in SemanticQuery.java
  var decodedGeneQuery = plusDecode(geneQuery);
  var decodedConditionQuery = plusDecode(conditionQuery);
  var decodedSpecies = plusDecode(species);
  return ["Query results for: ".concat(decodedGeneQuery) + (decodedConditionQuery ? ", in conditions ".concat(decodedConditionQuery) : "") + (decodedSpecies ? ", in species ".concat(decodedSpecies[0].toUpperCase() + decodedSpecies.slice(1).toLowerCase()) : "")];
};

var singleExperimentQueryDescription = function singleExperimentQueryDescription(_ref2) {
  var geneQuery = _ref2.geneQuery,
      _ref2$experiment = _ref2.experiment,
      description = _ref2$experiment.description,
      accession = _ref2$experiment.accession;
  var decodedGeneQuery = plusDecode(geneQuery);
  return [].concat(["Experiment accession: ".concat(accession)], // description can be empty, see ExperimentsCacheLoader.java or BaselineExperimentsBuilder.java
  description ? [description] : [], decodedGeneQuery ? ["Gene query: ".concat(decodedGeneQuery)] : []);
};

var getChartConfiguration = function getChartConfiguration(data, inProxy, outProxy, atlasUrl, isWidget, showControlMenu) {
  var experiment = data.experiment,
      profiles = data.profiles;
  var _data$config = data.config,
      species = _data$config.species,
      disclaimer = _data$config.disclaimer,
      columnType = _data$config.columnType;
  var chartTextDecorations = {
    introductoryMessage: introductoryMessage(experiment, profiles),
    xAxisLegendName: (0, _utils.capitalizeFirstLetter)(columnType) || "Experimental condition",
    yAxisLegendName: (0, _experimentTypeUtils.isMultiExperiment)(experiment) ? "Experiment" : "Gene name"
  };
  var description = ((0, _experimentTypeUtils.isMultiExperiment)(experiment) ? multiExperimentQueryDescription : singleExperimentQueryDescription)(Object.assign({}, data, data.config));
  var shortDescription = (0, _experimentTypeUtils.isMultiExperiment)(experiment) ? "expression_atlas-".concat(species.replace(/ +/, "_")) : experiment.accession;
  return Object.freeze(_objectSpread(_objectSpread({
    inProxy: inProxy,
    outProxy: outProxy,
    atlasUrl: atlasUrl,
    experiment: experiment,
    isWidget: isWidget,
    showControlMenu: showControlMenu,
    description: description,
    shortDescription: shortDescription,
    disclaimer: disclaimer
  }, chartTextDecorations), {}, {
    genomeBrowsers: data.config.genomeBrowsers,
    coexpressionsAvailable: Boolean(data.coexpressions),
    isMultiExperiment: (0, _experimentTypeUtils.isMultiExperiment)(experiment),
    isBaseline: (0, _experimentTypeUtils.isBaseline)(experiment),
    isDifferential: (0, _experimentTypeUtils.isDifferential)(experiment)
  }));
};

var _default = getChartConfiguration;
exports["default"] = _default;